var map = {
	"./de/btn-back.png": "zkl4",
	"./en/btn-back.png": "RgBh",
	"./es/btn-back.png": "lWTq",
	"./fr/btn-back.png": "gx+t",
	"./ja/btn-back.png": "SMgZ",
	"./ko/btn-back.png": "BcUb",
	"./pt/btn-back.png": "XiVU",
	"./ru/btn-back.png": "RYsW",
	"./th/btn-back.png": "kKso",
	"./zh-Hant/btn-back.png": "hH+O"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "HDnM";